import React from "react";

const TagOptions = ({ selectedTags = [], onTagsChange, availableTags = [] }) => {
  // Default available tags if none provided
  const defaultTags = [
    'diplomacy', 'international-relations', 'politics', 'economics', 
    'security', 'climate-change', 'human-rights', 'trade', 'development',
    'conflict-resolution', 'peace-building', 'governance', 'democracy'
  ];

  const tagsToUse = availableTags.length > 0 ? availableTags : defaultTags;

  function toCapitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const handleTagChange = (tag, isChecked) => {
    if (isChecked) {
      onTagsChange([...selectedTags, tag]);
    } else {
      onTagsChange(selectedTags.filter((t) => t !== tag));
    }
  };

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-gray-700">Select relevant tags</h4>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {tagsToUse.map((tag) => (
          <label key={tag} className="flex items-center space-x-2 cursor-pointer group">
            <input
              type="checkbox"
              checked={selectedTags.includes(tag)}
              value={tag}
              onChange={(e) => handleTagChange(tag, e.target.checked)}
              className="h-4 w-4 rounded border-gray-300 text-zinc-900 focus:ring-zinc-900/20 accent-zinc-900"
            />
            <span className="text-sm text-gray-700 group-hover:text-zinc-900 transition-colors">
              {toCapitalize(tag)}
            </span>
          </label>
        ))}
      </div>
      
      {selectedTags.length > 0 && (
        <div className="mt-4">
          <h5 className="text-sm font-medium text-gray-700 mb-2">Selected tags:</h5>
          <div className="flex flex-wrap gap-2">
            {selectedTags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-900 text-white border border-zinc-900"
              >
                {toCapitalize(tag)}
                <button
                  type="button"
                  onClick={() => handleTagChange(tag, false)}
                  className="ml-1.5 text-white/70 hover:text-white"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagOptions;
